import { GridColDef } from '@mui/x-data-grid-pro';
import styles from './DataGrid.DispatchEvent.module.css';
import { Tooltip } from '@mui/material';
import { DispatchEvent } from '@api/Trinium/Endpoints/DispatchEvent';
import DispatchEventMobileItem from './DispatchEventMobileItem';
import { ParsedDate } from '@api/Trinium/types';

export const dispatchEventColumnDefinitions: GridColDef<DispatchEvent>[] = [
  {
    field: 'eventDate',
    minWidth: 125,
    width: 125,
    headerName: 'Date',
    headerClassName: styles['grid-column-header'],
    renderCell: ({ row }) => (
      <span title={row.eventDate?.date}>
        {row.eventDate?.shortDateExtended} {row.eventDate?.time}
      </span>
    ),
    align: 'center',
    sortable: false,
    disableReorder: true,
    valueGetter: (value?: ParsedDate) => {
      return value?.dateTime;
    }
  },
  {
    field: 'eventType',
    minWidth: 225,
    flex: 1,
    headerName: 'Type',
    renderCell: ({ row }) => (
      <Tooltip title={row.eventType}>
        <span className={styles['table-cell-trucate']}>{row.eventType}</span>
      </Tooltip>
    ),
    headerClassName: styles['grid-column-header'],
    sortable: false,
    disableReorder: true
  },
  {
    field: 'userName',
    minWidth: 175,
    flex: 1,
    headerName: 'User',
    renderCell: ({ row }) => (
      <span title={row.userName}>
        {row.userId} {row.userName}
      </span>
    ),
    headerClassName: styles['grid-column-header'],
    sortable: false,
    disableReorder: true
  },
  {
    field: 'note',
    minWidth: 325,
    flex: 1,
    headerName: 'Event Description',
    renderCell: ({ row }) => (
      <Tooltip title={row.note}>
        <span className={styles['table-cell-trucate']}>{row.note}</span>
      </Tooltip>
    ),
    headerClassName: styles['grid-column-header'],
    sortable: false,
    disableReorder: true
  }
];

export const mobileDispatchEventColumnDefs: GridColDef<DispatchEvent>[] = [
  {
    field: 'Mobile Card',
    flex: 1,
    renderCell: ({ row }) => <DispatchEventMobileItem event={row} />
  },
  {
    field: 'eventType'
  }
];
